import React from 'react';
import PropTypes from 'prop-types';

import { FormItem, Textarea } from '@cw-ui/form-components';

import { FIELD_FORM_CONTROL_CLASS } from '../field-form-control-styles';

const TextareaField = ({ field, value, onChange, onBlur, helperText, errorText, disabled = false }) => {
  const maxLength = field.validation?.maxLength;
  const count = maxLength ? `${(value ?? '').length}/${maxLength}` : undefined;
  const hasError = Boolean(errorText);

  return (
    <FormItem
      id={field.id}
      labelText={field.label}
      labelProps={{ required: field.required, error: hasError }}
      shrink
      size="medium"
      fullWidth
      className={FIELD_FORM_CONTROL_CLASS}
    >
      <Textarea
        id={field.id}
        placeholder={field.placeholder}
        value={value ?? ''}
        onChange={event => onChange(event.target.value)}
        onBlur={onBlur}
        count={count}
        error={hasError}
        helperText={errorText ?? helperText}
        disabled={disabled}
        minRows={3}
        maxRows={6}
        inputProps={maxLength ? { maxLength } : undefined}
      />
    </FormItem>
  );
};

TextareaField.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
    validation: PropTypes.shape({ maxLength: PropTypes.number })
  }).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  helperText: PropTypes.string,
  errorText: PropTypes.string,
  disabled: PropTypes.bool
};

export default TextareaField;
